var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "comment__answer-to do-light-up-selector",
      on: { click: _vm.highlightComment }
    },
    [
      _c("div", { staticClass: "comment__answer-to-icon" }),
      _vm._v("\n    " + _vm._s(_vm.comment.user.username) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }